define(
//begin v1.x content
({
	loadingState: "Įkeliama...",
	errorState: "Atsiprašome, įvyko klaida"
})
//end v1.x content
);
